export const habaMyAccountNavigation = {
  myAccountNavigation: {
    customerData: {
      changeLoginData: 'Change login data',
      manageAddresses: 'Manage addresses',
      changeData: 'Change customer data',
      label: 'Customer data',
      kidsDataManagement: 'Manage children data',
    },
    general: {
      article: 'My items',
      history: 'My orders',
      overview: 'My overview',
      premium: 'Premium shipping',
      return: 'My returns',
      wishlist: 'My wishlist',
    },
    navigation: {
      heading: 'Account overview',
      orders: 'My orders',
      clientData: 'My customer data',
      personalData: 'Personal data',
      loginData: 'Login data',
      billingAddress: 'Billing address',
      deliveryAddress: 'My delivery addresses',
    },
  },
};
